'use client';

import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface SuggestedProduct {
  id: string;
  name: string;
  image: string;
  alt: string;
  pricePerKg: number;
  weight: string;
  inStock: boolean;
}

interface SuggestedProductsProps {
  products: SuggestedProduct[];
  onAddToCart: (productId: string) => void;
}

const SuggestedProducts = ({ products, onAddToCart }: SuggestedProductsProps) => {
  return (
    <div className="bg-card border border-border rounded-md p-6">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="SparklesIcon" size={20} className="text-primary" />
        <h2 className="font-heading font-bold text-xl text-foreground">
          You May Also Like
        </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {products.map((product) => (
          <div
            key={product.id}
            className="bg-background border border-border rounded-md overflow-hidden transition-smooth hover:shadow-elevation-md hover-lift"
          >
            <div className="relative h-40 overflow-hidden bg-muted">
              <AppImage
                src={product.image}
                alt={product.alt}
                className="w-full h-full object-cover"
              />
              {!product.inStock && (
                <div className="absolute inset-0 bg-black/60 flex items-center justify-center">
                  <span className="text-white text-xs font-medium">Out of Stock</span>
                </div>
              )}
            </div>

            <div className="p-4">
              <h3 className="font-heading font-semibold text-sm text-foreground mb-2 line-clamp-2">
                {product.name}
              </h3>

              <div className="flex items-center justify-between mb-3">
                <div>
                  <div className="font-data font-bold text-base text-primary">
                    ₹{product.pricePerKg.toFixed(2)}
                  </div>
                  <div className="text-xs text-muted-foreground">per kg</div>
                </div>
                <div className="text-xs font-medium text-muted-foreground bg-muted px-2 py-1 rounded">
                  {product.weight}
                </div>
              </div>

              <button
                onClick={() => onAddToCart(product.id)}
                disabled={!product.inStock}
                className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-md font-medium text-sm transition-smooth hover:shadow-elevation-md hover-lift disabled:opacity-50 disabled:cursor-not-allowed focus-ring"
              >
                <Icon name="ShoppingCartIcon" size={16} />
                <span>Add to Cart</span>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SuggestedProducts;